export default __webpack_public_path__ + "static/media/apoio-elas.c3d69609.png";